import ResetPW from './ResetPW';
import Route from './route';

export default {
  RenderProp: ResetPW,
  mainRoute: Route,
};
